// 用于读取变量
export default{
    userId:state => state.userId,
    token:state => state.token,
    productId:state => state.productId,
    videoId:state => state.videoId,
    channelType:state => state.channelType,
    operdir:state => state.operdir,
    channelList:state => state.channelList,
}


// WEBPACK FOOTER //
// ./src/store/getters.js